export default __webpack_public_path__ + "static/media/reglogin-m-bg.37a872a9.webp";